const CHART_MODE_MAX_ALLOWED = 30
const ALL_MODES = ['columns', 'stacked', 'bcolumns', 'bstacked']

const CHART_MODE_OPTIONS = {
  columns: { message: 'Columns Chart', icon: 'columns-chart-v2' },
  stacked: { message: 'Stacked Chart', icon: 'stacked-columns-chart-v2' },
  bcolumns: { message: 'Bar Columns Chart', icon: 'bars-chart-v2' },
  bstacked: { message: 'Bar Stacked Chart', icon: 'stacked-bars-chart-v2' }
}

export const getOverLimit = batches => {
  if (!batches?.length || !batches[0]?.answerVariants?.length) return false
  return CHART_MODE_MAX_ALLOWED < batches.length * batches[0].answerVariants.length
}

export const isAboveLimit = (batches, groupType, ignorePercents) => {
  if (getOverLimit(batches)) return true
  if (ignorePercents) return false
  const avLen = batches?.[0]?.answerVariants?.length || 0
  if (groupType === 'grouped' && CHART_MODE_MAX_ALLOWED < (batches?.length || 0)) return true
  if (groupType === 'interlaced' && CHART_MODE_MAX_ALLOWED < avLen) return true
  return false
}

export const getAvailableModes = ({ batches, ignorePercents, groupType }) => {
  let modes = ALL_MODES.slice()
  const overLimit = getOverLimit(batches)

  if (ignorePercents) {
    modes = modes.filter(m => m !== 'stacked' && m !== 'bstacked')
  }
  if (overLimit) {
    modes = modes.filter(m => m !== 'columns')
  }
  if (!ignorePercents && batches?.length) {
    const avLen = batches[0]?.answerVariants?.length || 0
    if (groupType === 'grouped' && CHART_MODE_MAX_ALLOWED < batches.length) {
      modes = modes.filter(m => m !== 'stacked')
    }
    if (groupType === 'interlaced' && CHART_MODE_MAX_ALLOWED < avLen) {
      modes = modes.filter(m => m !== 'stacked')
    }
  }
  return modes
}

export const getChartModeOptions = modes => Object.fromEntries(modes.map(m => [m, CHART_MODE_OPTIONS[m]]))

export const getDefaultChartMode = ({
  chartMode,
  questionChartMode,
  globalChartMode,
  batches,
  ignorePercents,
  groupType
}) => {
  let mode = chartMode === 'off' ? globalChartMode : chartMode
  mode = mode || questionChartMode || globalChartMode
  const available = getAvailableModes({ batches, ignorePercents, groupType })
  const defaultMode = isAboveLimit(batches, groupType, ignorePercents) ? 'bcolumns' : 'columns'
  return available.includes(mode) ? mode : defaultMode
}

export const mapToBuilderKey = chartMode => {
  switch (chartMode) {
    case 'columns':
      return 'dl_columns'
    case 'stacked':
      return 'dl_stacked'
    case 'bcolumns':
      return 'dl_bcolumns'
    case 'bstacked':
      return 'dl_bstacked'
    default:
      return 'dl_columns'
  }
}
